import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import { useAuth } from '../contexts/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';

const CartPage: React.FC = () => {
  const { items, updateQuantity, removeItem, shippingFee } = useCart();
  const { member } = useAuth();
  const navigate = useNavigate();

  const formatPrice = (p: number) => p.toLocaleString() + '원';
  const productTotal = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const totalPrice = productTotal + shippingFee;

  return (
    <>
      <Header />
      <div className="cart-page">
        <div className="cart-inner">
          <h2 className="cart-title">장바구니 ({items.length})</h2>

          {items.length === 0 ? (
            <div className="cart-empty">
              <svg viewBox="0 0 24 24" fill="#ddd" width="64" height="64">
                <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0020.01 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>
              </svg>
              <p>장바구니가 비어있습니다</p>
              <Link to="/" className="cart-shop-btn">쇼핑 계속하기</Link>
            </div>
          ) : (
            <div className="cart-layout">
              <div className="cart-items">
                {items.map(item => (
                  <div key={item.id} className="cart-item">
                    <Link to={`/product/${item.product_id}`} className="cart-item-image">
                      <img src={item.main_image || 'https://via.placeholder.com/120x120?text=No+Image'} alt={item.product_name} />
                    </Link>
                    <div className="cart-item-info">
                      <Link to={`/product/${item.product_id}`} className="cart-item-name">
                        {item.product_name || `상품 #${item.product_id}`}
                      </Link>
                      {item.option_name && (
                        <span className="cart-item-option">{item.option_name}</span>
                      )}
                      <div className="cart-item-price">{formatPrice(item.price)}</div>
                    </div>
                    <div className="cart-item-actions">
                      <div className="cart-qty">
                        <button onClick={() => updateQuantity(item.id, Math.max(1, item.quantity - 1))}>-</button>
                        <span>{item.quantity}</span>
                        <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
                      </div>
                      <div className="cart-item-subtotal">{formatPrice(item.price * item.quantity)}</div>
                      <button className="cart-item-remove" onClick={() => removeItem(item.id)}>
                        <svg viewBox="0 0 24 24" width="18" height="18" fill="#999">
                          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div className="cart-summary">
                <h3>주문 요약</h3>
                <div className="cart-summary-row">
                  <span>상품 금액</span>
                  <span>{formatPrice(productTotal)}</span>
                </div>
                <div className="cart-summary-row">
                  <span>배송비</span>
                  <span style={{ color: shippingFee > 0 ? '#e62e04' : '#00b894', fontWeight: 600 }}>
                    {shippingFee > 0 ? formatPrice(shippingFee) : '무료'}
                  </span>
                </div>
                <div className="cart-summary-divider" />
                <div className="cart-summary-row cart-summary-total">
                  <span>총 결제 금액</span>
                  <span>{formatPrice(totalPrice)}</span>
                </div>
                <button className="cart-checkout-btn" onClick={() => {
                  navigate('/order', {
                    state: {
                      items: items.map(item => ({
                        product_id: item.product_id,
                        product_name: item.product_name,
                        main_image: item.main_image,
                        price: item.price,
                        quantity: item.quantity,
                        option_name: item.option_name || undefined,
                        cart_id: item.id
                      })),
                      shippingFee
                    }
                  });
                }}>주문하기</button>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CartPage;
